import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

// material-ui
import { Button, Typography } from '@mui/material';
import LogoutIcon from '@mui/icons-material/Logout';

import useAuth from 'src/hooks/useAuth';
import DialogBuilder from 'src/utils/dialogBuilder';

const Logout = () => {
  const [open, setOpen] = useState(false);
  const { logout } = useAuth();
  const history = useNavigate();

  const handleLogout = async () => {
    await logout();
    history('/');
  };

  return (
    <>
      <Button
        onClick={() => setOpen(true)}
        startIcon={<LogoutIcon stroke={1.5} size="1.3rem" />}
      >
        <Typography variant="body2">Logout</Typography>
      </Button>
      <DialogBuilder
        content={'Are you sure you want to logout?'}
        onClose={() => setOpen(false)}
        onClick={handleLogout}
        open={open}
        maxWidth={'md'}
        acceptMsg={'Yes'}
        rejectMsg={'No'}
      />
    </>
  );
};

export default Logout;
